/*
 * 配置路由及左侧菜单信息
 * path: 路由path
 * name: 路由名称
 * hidden: 不显示在菜单栏
 * icon: 菜单图标
 * title: 菜单名称+页面title
 * components: 页面组件
 */

//一级路由
export const index = {
  path: '/',
  hidden: true,
  redirect: '/course/livelist'
}

//课程管理
const course = {
  path: '/course',
  name: 'course',
  icon: 'course',
  meta: {
    title: '课程管理'
  },
  component: () => import('@/views/index/index.vue'),
  children: [{
      path: '/course/livelist',
      name: 'live_list',
      meta: {
        title: '直播',
      },
      component: () => import('@/views/course/live/list.vue')
    },
    {
      path: '/course/live-add',
      name: 'live_add',
      hidden: true,
      meta: {
        title: '创建直播',
      },
      component: () => import('@/views/course/live/add.vue')
    },
    {
      path: '/course/live-edit/:id',
      name: 'live_edit',
      hidden: true,
      meta: {
        title: '编辑直播',
      },
      component: () => import('@/views/course/live/edit.vue')
    },
    {
      path: '/course/speciallist',
      name: 'special_list',
      meta: {
        title: '专题',
      },
      component: () => import('@/views/course/special/list.vue')
    },
    {
      path: '/course/specialadd',
      name: 'special_add',
      hidden: true,
      meta: {
        title: '创建专题',
      },
      component: () => import('@/views/course/special/add.vue')
    },
    {
      path: '/course/specialedit/:id',
      name: 'special_edit',
      hidden: true,
      meta: {
        title: '编辑专题',
      },
      component: () => import('@/views/course/special/edit.vue')
    },
    {
      path: '/course/specialmanage/:id',
      name: 'special_manage',
      hidden: true,
      meta: {
        title: '专题内容管理',
      },
      component: () => import('@/views/course/special/special-manage.vue')
    },
    {
      path: '/course/audiolist',
      name: 'audio_list',
      meta: {
        title: '音频',
      },
      component: () => import('@/views/course/audio/list.vue')
    },
    {
      path: '/course/audio-add',
      name: 'audio_add',
      hidden: true,
      meta: {
        title: '创建音频',
      },
      component: () => import('@/views/course/audio/add.vue')
    },
    {
      path: '/course/audio-edit/:id',
      name: 'audio_edit',
      hidden: true,
      meta: {
        title: '编辑音频',
      },
      component: () => import('@/views/course/audio/edit.vue')
    },
    // 查看讨论内容
    {
      path: '/course/discuss/:id',
      name: 'discuss',
      hidden: true,
      meta: {
        title: '课程讨论内容',
      },
      component: () => import('@/views/course/components/discuss.vue')
    },
  ]
}
//通知事项
const matter = {
  path: '/matter',
  name: 'matter',
  icon: 'course',
  hidden: true,
  redirect:'/matter/notice',
  meta: {
    title: '通知事项'
  },
  component: () => import('@/views/index/index.vue'),
  children: [{
      path: '/matter/operate',
      name: 'operate',
      hidden: false,
      meta: {
        title: '社群运营',
      },
      component: () => import('@/views/matter/operate.vue')
    },
    {
      path: '/matter/notice',
      name: 'notice',
      hidden: false,
      meta: {
        title: '通知中心',
      },
      component: () => import('@/views/matter/notice.vue')
    },
  ]
}

//用户管理
const user_manage = {
  path: '/user',
  name: 'user',
  icon: 'user',
  meta: {
    title: '用户管理'
  },
  component: () => import('@/views/index/index.vue'),
  children: [{
      path: '/user/user-list',
      name: 'user_list',
      hidden: false,
      meta: {
        title: '用户列表',
      },
      component: () => import('@/views/user/user-list.vue')
    },
    {
      path: '/user/user-descript',
      name: 'user_descript',
      hidden: true,
      meta: {
        title: '用户详情',
      },
      component: () => import('@/views/user/user-descript/user-descript.vue')
    },
    {
    path: '/user/user-personmessage',
      name: 'user_personmessage',
      hidden: true,
      meta: {
        title: '全员消息',
      },
      component: () => import('@/views/user/person-message.vue')
    },
    {
      path: '/user/message-list',
      name: 'message_list',
      hidden: false,
      meta: {
        title: '消息列表',
      },
      component: () => import('@/views/user/message-list.vue')
    },
    {
      path: '/user/comment',
      name: 'comment',
      hidden: false,
      meta: {
        title: '评论管理',
      },
      component: () => import('@/views/user/comment.vue')
    },
    {
      path: '/user/cooperate',
      name: 'cooperate',
      hidden: false,
      meta: {
        title: '求合作',
      },
      component: () => import('@/views/user/cooperate.vue')
    },
    {
      path: '/user/lock-course',
      name: 'lock_course',
      hidden: false,
      meta: {
        title: '锁定课程',
      },
      component: () => import('@/views/user/lock-course.vue')
    },
    {
      path: '/user/add-lockcourse',
      name: 'add_lockcourse',
      hidden: true,
      meta: {
        title: '表单控件管理',
      },
      component: () => import('@/views/user/add-lockcourse.vue')
    },
    {
      path: '/user/feedback',
      name: 'feedback',
      hidden: false,
      meta: {
        title: '用户反馈',
      },
      component: () => import('@/views/user/feedback.vue')
    },
  ]
}

//订单管理
const payment = {
  path: '/payment',
  name: 'payment',
  icon: 'deal',
  meta: {
    title: '交易管理'
  },
  component: () => import('@/views/index/index.vue'),
  children: [{
      path: '/payment/order',
      name: 'order',
      hidden: false,
      meta: {
        title: '订单管理',
      },
      component: () => import('@/views/payment/order.vue'),
    },
    {
      path: '/payment/money-reward',
      name: 'money_reward',
      hidden: false,
      meta: {
        title: '打赏管理',
      },
      component: () => import('@/views/payment/money-reward.vue')
    },
    {
      path: '/payment/order/descript/:id',
      name: 'order_descript',
      hidden: true,
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/payment/order-descript.vue')
    },
    {
      path: '/payment/money-reward/descript/:id',
      name: 'reward_descript',
      hidden: true,
      meta: {
        title: '打赏详情',
      },
      component: () => import('@/views/payment/reward-descript.vue')
    }
  ]
}

//界面管理
const Interface = {
  path: '/interface',
  name: 'interface',
  icon: 'view',
  meta: {
    title: '界面管理'
  },
  component: () => import('@/views/index/index.vue'),
  children: [{
      path: '/interface/banner',
      name: 'banner',
      hidden: false,
      meta: {
        title: '首页banner',
      },
      component: () => import('@/views/interface/banner.vue')
    },
    {
      path: '/interface/hot-search',
      name: 'hot_search',
      hidden: false,
      meta: {
        title: '热门搜索',
      },
      component: () => import('@/views/interface/hot-search.vue')
    },
  ]
}

//界面管理
const system = {
  path: '/system',
  name: 'system',
  icon: 'setting',
  meta: {
    title: '设置'
  },
  component: () => import('@/views/index/index.vue'),
  children: [{
      path: '/system/personnel',
      name: 'personnel',
      hidden: false,
      meta: {
        title: '员工管理',
      },
      component: () => import('@/views/system/personnel/personnel.vue')
    },
    {
      path: '/system/personnel/add',
      name: 'personnel_add',
      hidden: true,
      meta: {
        title: '添加员工',
      },
      component: () => import('@/views/system/personnel/add.vue')
    },
    {
      path: '/system/personnel/edit/:id',
      name: 'personnel_edit',
      hidden: true,
      meta: {
        title: '编辑员工',
      },
      component: () => import('@/views/system/personnel/edit.vue')
    },
    {
      path: '/system/role',
      name: 'role',
      hidden: false,
      meta: {
        title: '角色管理',
      },
      component: () => import('@/views/system/role/role.vue')
    },
    {
      path: '/system/role/add',
      name: 'role_add',
      hidden: true,
      meta: {
        title: '添加角色',
      },
      component: () => import('@/views/system/role/add.vue')
    },
    {
      path: '/system/role/edit/:id',
      name: 'role_edit',
      hidden: true,
      meta: {
        title: '编辑角色',
      },
      component: () => import('@/views/system/role/edit.vue')
    },
  ]
}

//直播页面
const live = {
  path: '/live/:id',
  name: 'live',
  hidden: true,
  meta: {
    title: '直播'
  },
  component: () => import('@/views/live/index.vue')
}

//404页面
export const errorPage = {
  path: '*',
  name: 'error_404',
  hidden: true,
  meta: {
    title: '找不到该页面'
  },
  component: () => import('@/views/error/error-404.vue')
}

//不需要动态添加的路由表
export const constRouters = [{
    path: '/login',
    name: 'login',
    hidden: true,
    meta: {
      title: '登录'
    },
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/password-find',
    name: 'password-find',
    hidden: true,
    meta: {
      title: '找回密码'
    },
    component: () => import('@/views/password-find/password-find.vue')
  },
  {
    path: '/error403',
    name: 'error-403',
    hidden: true,
    meta: {
      title: '权限不足'
    },
    component: () => import('@/views/error/error-403.vue')
  },
  // live,
  matter,
  // course,
  // user_manage,
  // payment,
  // Interface,
  // system
]

const routes = [
  ...constRouters
]

//需要动态添加的路由表
export const asyncRouters = {
  course,
  user_manage,
  payment,
  Interface,
  system
}

//后端路由表与前端路由表对应关系
export const ROUTES_MAP = [
   {
    id: '1',
    name: 'course'
  },
  {
    id: '2',
    name: 'user_manage'
  },
  {
    id: '3',
    name: 'payment'
  },
  {
    id: '4',
    name: 'Interface'
  },
  {
    id: '5',
    name: 'system'
  }
]

export default routes
